import { REHYDRATE } from "redux-persist";

export default (predicate) => (reducer) => (state, action) =>
  state === undefined || action.type === REHYDRATE || predicate(action)
    ? reducer(state, action)
    : state;
